<template>
  <div class="data-query">
    <headImg></headImg>
    <statisticsData :headImgs="headImgs"></statisticsData>
    <statisticsStudy></statisticsStudy>
    <statisticsOther></statisticsOther>
  </div>
</template>
<script>
import headImg from "./module/head";
import statisticsData from "./module/statisticsData";
import statisticsStudy from "./module/statisticsStudy";
import statisticsOther from "./module/statisticsOther";

export default {
  data() {
    return {
      headImgs: []
    };
  },
  components: {
    headImg,
    statisticsData,
    statisticsStudy,
    statisticsOther
  },
  methods: {
    getLoginMsg() {
      this.axios
        .post("/api/Statistics/RegistrationCount", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.headImgs.push({ title: "注册人数统计", data: e.data.count });
              break;
            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPartyMsg() {
      this.axios
        .post("/api/Statistics/PartyCount", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.headImgs.push({
                title: "党员人数统计",
                data: e.data.count
              });
              break;
            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getLoginMsg();
    this.getPartyMsg();
  }
};
</script>
<style lang='scss' scoped>
.data-query {
  padding-bottom: 1.2rem;
}
</style>